import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, normalizeProps as _normalizeProps, guardReactiveProps as _guardReactiveProps, renderSlot as _renderSlot, resolveDynamicComponent as _resolveDynamicComponent, withCtx as _withCtx, renderList as _renderList, createSlots as _createSlots, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { ElTableColumn as WrappedComponent } from 'element-plus';
import 'element-plus/lib/components/table-column/style/css';

export default /*#__PURE__*/_defineComponent({
  __name: 'NkTableColumn',
  setup(__props) {


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_resolveDynamicComponent(_unref(WrappedComponent)), _normalizeProps(_guardReactiveProps(_ctx.$attrs)), _createSlots({ _: 2 }, [
    _renderList(_ctx.$slots, (_, slot) => {
      return {
        name: slot,
        fn: _withCtx((scope) => [
          _renderSlot(_ctx.$slots, slot, _normalizeProps(_guardReactiveProps(scope || {})))
        ])
      }
    })
  ]), 1040))
}
}

})